<template>
    <div class="wrapper">
        <h2>产品功能</h2>
        <div class="production">
            <ProductItem v-for="(item, index) in data" :key="index" :item="item" />
        </div>
    </div>
</template>
<script>
import ProductItem from "../components/ProductItem"

import thought from "../assets/production/thought.svg"
import raid from "../assets/production/raid.svg"
import hacker from "../assets/production/hacker.svg"
import network from "../assets/production/network.svg"
import virus from "../assets/production/virus.svg"
import interactive from "../assets/production/interactive.svg"

const data = [
    {
        title: "捕获高级未知威胁，防微杜渐",
        desc: "传统的网络安全产品，都分别有各自的应用场景，能针对解决一些特定条件下的网络攻击防御、预警、缓解和加固，但对于未知的0day漏洞等攻击却无能为力。360攻击欺骗防御系统基于攻击行为检测，能够捕获未知类型攻击。",
        img: thought
    },
    {
        title: "内网威胁感知，保护真实资产",
        desc: "传统防御手段大多基于网络边界的检测，利用规则检测试图阻止攻击者的入侵，然而当黑客使用更加精密的新型攻击技术突破边界防线、进入企业内网时，传统防御手段无法及时发现和拦截。360攻击欺骗防御系统位于企业内网中，以高度逼真的特点迷惑攻击者，在保护企业真实资产的同时捕获内网威胁。",
        img: raid
    },
    {
        title: "高仿真高交互服务，让攻击者真假难辨",
        desc: "360攻击欺骗防御系统通过自定义配置仿真服务（系统服务、Web服务、数据库服务等），灵活搭建真实可变的蜜网环境，满足不同场景下的需求。不仅如此，还可在攻击链的每一个环节（侦查目标、攻击入侵、命令控制、横向渗透、数据外泄、痕迹清理）投放蜜饵、蜜标与面包屑，等待攻击者上钩。",
        img: interactive
    },
    {
        title: "实时告警、快速响应",
        desc: "产品支持邮件告警，系统提供威胁告警和探针状态两大类告警，当检测到外部威胁或探针工作状态变化时，会向用户发送实时告警，用户也可自由配置告警策略，避免打扰。",
        img: virus
    },
    {
        title: "安全设备联动、数据多维分析",
        desc: "360攻击欺骗防御系统支持Syslog日志导出，能够与企业已有安全产品联动，实现数据多维度、关联分析。",
        img: hacker
    },
    {
        title: "简易部署、易于维护",
        desc: "系统由Agent端、Server端、WEB管理平台构成，用户只需一条终端指令就可运行一个新的Agent，在WEB管理平台可对Agent进行配置管理，操作简单。",
        img: network
    },
]
export default {
    components: {
        ProductItem
    },
    data() {
        return {
            data
        }
    }
}
</script>
<style>
.production{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 50px;
}
</style>